import {Button} from 'antd';
import React, {FC} from 'react';

import {ModalOpenerComponent} from 'components/modal-opener-component';
import {ActionButton} from 'components/table/action/action-button';
import {ITableActionProps} from 'components/table/action/table-action-types';
import {createStringDate} from 'components/table/utils/table.utils';
import {EButtonType} from 'entities/metadata';
import {TEntity} from 'modules/data';
import {DATE_DMY} from 'shared/constants/date-format';

import {useFactorInfluenceInfoItemModal} from '../hooks';
import {
    FACTOR_INFLUENCE_INFO_ITEM_MODAL_BUTTON_TYPE,
    FACTOR_INFLUENCE_INFO_ITEM_MODAL_TAB_KEYS,
} from '../model/constants';
import {FactorInfluenceInfoItemModalForm} from './factor-influence-info-item-modal-form';

interface IFactorInfluenceInfoItemModalOpenerProps extends ITableActionProps {
    record?: TEntity;
    buttonViewType?: (typeof FACTOR_INFLUENCE_INFO_ITEM_MODAL_BUTTON_TYPE)[keyof typeof FACTOR_INFLUENCE_INFO_ITEM_MODAL_BUTTON_TYPE];
    buttonTitle?: string;
    tabKey?: (typeof FACTOR_INFLUENCE_INFO_ITEM_MODAL_TAB_KEYS)[keyof typeof FACTOR_INFLUENCE_INFO_ITEM_MODAL_TAB_KEYS];
}

const READONLY_FACTOR = 'SEND_SUCCESS';

export const FactorInfluenceInfoItemModalOpener: FC<IFactorInfluenceInfoItemModalOpenerProps> = ({
    meta,
    wrapper,
    entityName,
    record,
    buttonViewType = FACTOR_INFLUENCE_INFO_ITEM_MODAL_BUTTON_TYPE.PRIMARY,
    buttonTitle,
    tabKey = FACTOR_INFLUENCE_INFO_ITEM_MODAL_TAB_KEYS.MAIN,
    ...props
}: IFactorInfluenceInfoItemModalOpenerProps) => {
    const {
        modalRef,
        isOpen,
        isLoading,
        form,
        activeTab,
        setActiveTab,
        effectInfluence,
        setEffectInfluence,
        setIsOpen,
        handleCloseModal,
        handleFinish,
        handleSave,
    } = useFactorInfluenceInfoItemModal({entityName, wrapper, record, tabKey});

    const getButtonComponent = () => {
        const title = meta.actionTitle || buttonTitle;

        switch (buttonViewType) {
            case FACTOR_INFLUENCE_INFO_ITEM_MODAL_BUTTON_TYPE.DETAIL:
                return (
                    <Button
                        type={EButtonType.link}
                        size="middle"
                    >
                        {title}
                    </Button>
                );
            case FACTOR_INFLUENCE_INFO_ITEM_MODAL_BUTTON_TYPE.PRIMARY:
                return (
                    <ActionButton
                        {...props}
                        buttonType={EButtonType.primary}
                        actionIcon="PlusCircleOutlined"
                    >
                        {title}
                    </ActionButton>
                );
            case FACTOR_INFLUENCE_INFO_ITEM_MODAL_BUTTON_TYPE.LINK_DATE:
                return (
                    <Button type={EButtonType.link}>{createStringDate(record?.reportingDate, DATE_DMY) || '-'}</Button>
                );
            default:
                return undefined;
        }
    };

    const isReadOnly = record?.statusText === READONLY_FACTOR;

    return (
        <ModalOpenerComponent
            ref={modalRef}
            isOpen={isOpen}
            isLoading={isLoading}
            setIsOpen={setIsOpen}
            handleSave={handleSave}
            handleCancel={(setIsModalOpen) => {
                handleCloseModal(setIsModalOpen);
            }}
            controlLabels={{save: 'Сохранить'}}
            hideControls={{cancel: true}}
            component={getButtonComponent()}
            modalProps={{
                title: 'Сведения о макроэкономических факторах',
                forceRender: true,
                centered: true,
                destroyOnClose: true,
            }}
        >
            {isOpen && <FactorInfluenceInfoItemModalForm
                form={form}
                handleFinish={handleFinish}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                effectInfluence={effectInfluence}
                setEffectInfluence={setEffectInfluence}
                isReadOnly={isReadOnly}
            />}
        </ModalOpenerComponent>
    );
};
